<template>
  <Modal
    class="subscribe-modal"
    :closable="false"
    :mask-closable="false"
    footer-hide
    :width="420"
    v-model="isSpecialTips"
  >
    <div class="subscribe-box">
      <img src="./image/bg.png" alt="bg" class="bg" />
      <div class="body">
        <h2>
          <img src="./image/icon.png" alt="icon" class="icon" />
          <span class="title">{{ $t('team.tip') }}</span>
        </h2>
        <div class="content">
          <p class="text">{{ $t('subscribe.tips') }}</p>
        </div>
      </div>

      <Row type="flex" justify="center" :gutter="12" class="subscribe-btn-box">
        <Col>
          <div class="btn secondary" @click="onLogOut">
            {{ $t('subscribe.logOut') }}
          </div>
        </Col>
        <Col>
          <div class="btn primary" @click="onSwitch">
            {{ $t('subscribe.switchTeam') }}
          </div>
        </Col>
      </Row>
    </div>
  </Modal>
</template>

<script>
import { AuthManage } from '@/plugins/auth';
import { mapState, mapMutations } from 'vuex';
export default {
  computed: {
    ...mapState({
      isSpecialTips: (state) => state.isSpecialTips
    })
  },
  watch: {
    isSpecialTips(val) {
      if (val) {
        this.onInterceptClick();
      } else {
        this.onRemoveInterceptClick();
      }
    }
  },
  methods: {
    ...mapMutations({
      setSpecialTips: 'setSpecialTips',
      selectTeamChange: 'selectTeamChange'
    }),
    // 切换团队
    onSwitch() {
      this.setSpecialTips(false);
      this.selectTeamChange(true);
    },
    // 退出登录
    onLogOut() {
      AuthManage.logoutFn();
    },
    // 订阅过期时监听点击事件
    listeningToClickEvent(e) {
      const path = e.path || (e.composedPath && e.composedPath());
      const classNames = [];
      _.forEach(path, (f) => {
        if (typeof f.className === 'string') {
          classNames.push(f.classList[0]);
        }
      });
      if (
        !_.includes(classNames, 'ivu-modal-wrap') &&
        !_.includes(classNames, 'subscribe')
      ) {
        window.location.reload();
        e.stopImmediatePropagation();
      }
    },
    // 添加拦截点击事件
    onInterceptClick() {
      document.addEventListener('click', this.listeningToClickEvent, true);
      this.$once('hook:destroyed', () => {
        document.removeEventListener('click', this.listeningToClickEvent, true);
      });
    },
    // 删除拦截点击事件
    onRemoveInterceptClick() {
      document.removeEventListener('click', this.listeningToClickEvent, true);
    }
  }
};
</script>
<style lang="less" scoped>
.subscribe-modal {
  .ivu-modal {
    border-top: 1px solid #dda15e;
  }

  .subscribe-box {
    padding: 24px 10px 0 10px;
  }

  .bg {
    display: block;
    width: 100%;
    height: 240px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    pointer-events: none;
  }

  .body {
    height: 180px;
    position: relative;
    z-index: 2;
    color: #1f2329;

    h2 {
      display: flex;
      align-items: baseline;
      justify-content: left;
      min-height: 34px;
      margin: 0 0 14px 0;
    }

    .icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      margin-right: 4px;
      position: relative;
      bottom: -3px;
    }

    .title {
      text-align: left;
      line-height: 1;
    }

    .text {
      line-height: 20px;
      text-align: left;
    }
  }

  .subscribe-btn-box {
    width: 100%;
    margin: 20px 0;

    .btn {
      height: 36px;
      border-radius: 18px;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
      padding: 0 30px;
    }

    .primary {
      color: #fff;
      line-height: 36px;
      background-color: #dda15e;
    }

    .secondary {
      color: #dda15e;
      line-height: 34px;
      border: 1px solid #dda15e;
    }
  }
}
</style>
